import { useCallback, useEffect, useState } from 'react';
import { ApplicationComment } from '../../../../../hoc/new-application/types';
import {
  useDeleteNewApplicationCommentMutation,
  useUpdateNewApplicationCommentMutation,
} from '../../../../../hoc/new-application/store/services';

const useComment = ({
  comment,
  applicationId,
}: {
  comment: ApplicationComment;
  applicationId?: string;
}) => {
  const [commentValue, setCommentValue] = useState(comment?.text);
  const [edit, setEdit] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);

  const [
    updateComment,
    { isLoading: updateIsLoading, isSuccess: updateIsSuccess },
  ] = useUpdateNewApplicationCommentMutation();
  const [
    deleteComment,
    { isLoading: deleteInProgress, isSuccess: deleteIsSuccess },
  ] = useDeleteNewApplicationCommentMutation();

  const updateCommentAction = useCallback(() => {
    updateComment({
      id: applicationId as string,
      commentId: comment.id,
      body: {
        text: commentValue,
      },
    });
  }, [commentValue]);

  useEffect(() => {
    if (deleteIsSuccess) {
      setPopupVisible(false);
    }
  }, [deleteIsSuccess]);

  useEffect(() => {
    if (updateIsSuccess) {
      setEdit(false);
    }
  }, [updateIsSuccess]);

  return {
    edit,
    commentValue,
    setCommentValue,
    updateIsLoading,
    updateCommentAction,
    setEdit,
    setPopupVisible,
    deleteComment,
    deleteInProgress,
    popupVisible,
  };
};

export default useComment;
